import { Component } from "react";
import PropTypes from "prop-types";
import Link from "admin/shared/ui/Link.Component";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import TextField from "@material-ui/core/TextField";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";

import CurrencyFormater from "../../../shared/ui/Currency.Input";

import { orange500, blue500 } from "material-ui/styles/colors";
import _ from "underscore";
import { accountingConnector } from "../../../services/accounting/connector";
import { compose } from "redux";
import InvestorDepositImport from "./InvestorDepositImport/Accounting.InvestorDepositImport.Component";
import InvoicePaymentImport from "./InvoicePaymentImport/Accounting.InvoicePaymentImport.Component";
import { Currencies as CurrencyEnum } from "../../../shared/dictionary/enums";
import { FormControlLabel, MenuItem } from "@material-ui/core";
import { currencyList } from "../../../shared/dictionary/static";
import Checkbox from "@material-ui/core/Checkbox";

class AccountingRegisteringComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Batch: [],
      Failed: [],
      PaymentId: "",
      Amount: "",
      RefCode: "",
      IsSalesPerformanceExcluded: false,
      BankReceiveDate: new Date(),
      Currency: CurrencyEnum.Sek,
      matchStyle: this.styles.matchedStyle,
      matchText: "",
      isDialogOpen: false,
    };
  }

  styles = {
    errorStyle: {
      color: orange500,
    },
    matchedStyle: {
      color: blue500,
    },
  };

  componentDidMount() {
    this.props.getUnmatchedInvoiceData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //That means that the payment was sent without any problem
    if (
      this.props.accounting.depositPayments.sent === false &&
      nextProps.accounting.depositPayments.sent === true
    ) {
      this.setState({
        PaymentId: "",
        Amount: "",
        RefCode: "",
        BankReceiveDate: new Date(),
        matchStyle: this.styles.matchedStyle,
        matchText: "",
      });
    }
    if (
      this.props.accounting.invoicePayments.sent === false &&
      nextProps.accounting.invoicePayments.sent === true
    ) {
      this.setState({
        PaymentId: "",
        Amount: "",
        RefCode: "",
        BankReceiveDate: new Date(),
        matchStyle: this.styles.matchedStyle,
        matchText: "",
      });
    }
  }

  render() {
    let matchedInvestorDeposits =
      this.props.accounting.investorDepositsToTransfer.data;

    let matchedDeposits = _.filter(
      this.props.accounting.depositPayments.data,
      (item) => {
        return (
          // eslint-disable-next-line no-prototype-builtins
          this.props.accounting.matchedDeposits.data.hasOwnProperty(item.Id) ===
          true
        );
      },
    );

    let matchedInvoices = this.props.accounting.matchedInvoices.data;

    let wrapperStyle = {
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
    };
    let halfItemStyle = {
      width: "50%",
      padding: "10px",
      boxSizing: "border-box",
    };

    return (
      <div>
        <div className="accounting-layout body-height" style={wrapperStyle}>
          <div style={halfItemStyle}>
            <Card style={{ height: "100%" }}>
              <CardHeader
                title="Register new deposit or invoice"
                subheader={" "}
              />
              <CardContent>
                <TextField
                  size="small"
                  variant="outlined"
                  id="refCode"
                  value={this.state.RefCode}
                  onChange={this.changeRefCode}
                  onBlur={this.blurRefCode}
                  label="Ref code"
                  fullWidth={true}
                  errorText={this.state.matchText}
                  errorStyle={this.state.matchStyle}
                />
                <br />
                <TextField
                  size="small"
                  variant="outlined"
                  id="paymentId"
                  value={this.state.PaymentId}
                  onChange={this.changePaymentId}
                  fullWidth={true}
                  label="Payment id"
                />
                <br />
                <CurrencyFormater
                  id="amount"
                  value={this.state.Amount}
                  onChange={this.changeAmount}
                  fullWidth={true}
                  label="Amount"
                />
                <br />
                <DatePicker
                  inputVariant="outlined"
                  className="small-datepicker"
                  value={this.state.BankReceiveDate}
                  onChange={this.changeBankReceiveDate}
                  fullWidth={true}
                  label="Bank registered date"
                />
                <br />
                <TextField
                  select
                  style={{ paddingBottom: "16px" }}
                  label={"Currency"}
                  onChange={this.changeCurrency}
                  value={this.state.Currency}
                >
                  {currencyList.map((item) => {
                    return (
                      <MenuItem key={item.value} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <br />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.IsSalesPerformanceExcluded}
                      onClick={this.changeIsSalesPerformanceExcluded}
                    />
                  }
                  label="Exclude from Sales performance"
                />
                <p>Register as:</p>
              </CardContent>
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  id="depositPayment"
                  onClick={() => this.registerInvestorDeposit()}
                >
                  Investor deposit
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.Currency !== CurrencyEnum.Sek}
                  onClick={() => this.registerInvoice()}
                >
                  Invoice payment
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.Currency !== CurrencyEnum.Sek}
                  style={{ marginLeft: "100px" }}
                  onClick={() => this.registerDcaCollection()}
                >
                  DCA collection
                </Button>
              </CardActions>
            </Card>
          </div>
          <div style={halfItemStyle}>
            <Card style={{ height: "100%" }}>
              <CardHeader
                title="Deposits or invoices matched"
                subheader={" "}
              />
              <CardContent>
                <List>
                  <Link toState={"confirmInvestorDeposits"}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>{matchedInvestorDeposits.length}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary="Matched Investor Deposits" />
                    </ListItem>
                  </Link>
                  <Link toState={"confirmPaymentsInvoices"}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>{matchedInvoices.length}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary="Matched Invoice Payments" />
                    </ListItem>
                  </Link>
                  <Link toState={"confirmPaymentsDeposits"}>
                    <ListItem>
                      <ListItemAvatar>
                        <Avatar>{matchedDeposits.length}</Avatar>
                      </ListItemAvatar>
                      <ListItemText primary="Matched Deposit Payments" />
                    </ListItem>
                  </Link>
                </List>
              </CardContent>
            </Card>
          </div>
        </div>
        <InvestorDepositImport {...this.props} />
        <InvoicePaymentImport {...this.props} />
      </div>
    );
  }

  openInfoDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  closeInfoDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  changePaymentId = (event) => {
    this.setState({
      PaymentId: event.target.value,
    });
  };

  changeAmount = (event) => {
    this.setState({
      Amount: event.target.value,
    });
  };

  changeCurrency = (event) => {
    this.setState({
      Currency: event.target.value,
    });
  };

  changeIsSalesPerformanceExcluded = (event) => {
    this.setState({
      IsSalesPerformanceExcluded: event.target.checked,
    });
  };

  blurRefCode = (event) => {
    var match = _.findIndex(this.props.deposits.data, (value) => {
      return value.RefCode === event.target.value;
    });

    var invoicesMatch = _.findIndex(this.props.invoices.data, (value) => {
      return value.RefCode === event.target.value;
    });

    var stInvoicesMatch = _.findIndex(this.props.stInvoices.data, (value) => {
      return value.RefCode === event.target.value;
    });

    if (match > -1) {
      this.setState({
        matchStyle: this.styles.matchedStyle,
        matchText: "Found deposit order match",
      });
    } else if (invoicesMatch > -1) {
      this.setState({
        matchStyle: this.styles.matchedStyle,
        matchText: "Found invoice match",
      });
    } else if (stInvoicesMatch > -1) {
      this.setState({
        matchStyle: this.styles.matchedStyle,
        matchText: "Found short term invoice match",
      });
    } else {
      this.setState({
        matchStyle: this.styles.errorStyle,
        matchText: "Didn't find deposit order or invoice match",
      });
    }
  };

  changeRefCode = (event) => {
    this.setState({
      RefCode: event.target.value,
    });
  };

  changeBankReceiveDate = (value) => {
    this.setState({
      BankReceiveDate: value,
    });
  };

  registerInvestorDeposit = () => {
    let data = {
      PaymentId: this.state.PaymentId,
      Amount: this.state.Amount.replace(",", "."),
      RefCode: this.state.RefCode.replace(/\s+/g, ""),
      BankReceiveDate: this.state.BankReceiveDate,
      Currency: this.state.Currency,
      IsSalesPerformanceExcluded: this.state.IsSalesPerformanceExcluded,
    };
    this.props.registerPayment(data, "investor_deposit");
    this.props.attachIntervals();
  };

  registerInvoice = () => {
    var data = {
      PaymentId: this.state.PaymentId,
      Amount: this.state.Amount.replace(",", "."),
      OCR: this.state.RefCode.replace(/\s+/g, ""),
      BankReceiveDate: this.state.BankReceiveDate,
    };
    this.props.registerPayment(data, "invoice");
    this.props.attachIntervals();
  };

  registerDcaCollection = () => {
    var data = {
      PaymentId: this.state.PaymentId,
      Amount: this.state.Amount.replace(",", "."),
      OCR: this.state.RefCode.replace(/\s+/g, ""),
      BankReceiveDate: this.state.BankReceiveDate,
    };
    this.props.registerPayment(data, "dca_collection");
    this.props.attachIntervals();
  };

  static propTypes = {
    accounting: PropTypes.any,
    deposits: PropTypes.any,
    invoices: PropTypes.any,
    stInvoices: PropTypes.any,
    registerPayment: PropTypes.func,
    registerDcaCollection: PropTypes.func,
    attachIntervals: PropTypes.func,
    getUnmatchedInvoiceData: PropTypes.func,
    registerInvoiceBatchPayment: PropTypes.func,
  };
}
export default compose(accountingConnector)(AccountingRegisteringComponent);
